import Vue from 'vue';
import lodash from 'lodash';

import '@/common.css';
import '@/animate.css';
import VueClipboard from 'vue-clipboard2';
import {
  Image as VanImage,
  Icon as VanIcon,
  Divider,
  Lazyload,
  Loading,
} from 'vant';
// eslint-disable-next-line import/no-unresolved
import VueTouch from 'vue-touch'; // 移动端滑动监听
// 新建页面修改这两个导入即可
import App from '../src/pages/index/App';
import router from '../src/router/index';

Vue.use(VueTouch, { name: 'v-touch' });
Vue.use(Lazyload);
Vue.use(Loading);
Vue.use(Divider);
Vue.use(VanImage);
Vue.use(VanIcon);
Vue.use(VueClipboard);

Vue.prototype.lodash = lodash;
// eslint-disable-next-line no-new
new Vue({
  router,
  el: '#app',
  render: (h) => h(App),
});
